import { render, staticRenderFns } from "./reject-vendor.vue?vue&type=template&id=48a0d2f6&scoped=true"
import script from "./reject-vendor.vue?vue&type=script&lang=js"
export * from "./reject-vendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a0d2f6",
  null
  
)

export default component.exports